module.exports = __webpack_public_path__ + "static/media/testimonial-img2.cc14ff4a.jpg";